import { useState } from 'react';
import PropTypes from 'prop-types';

function IconAddOrg({
  className,
  width,
  height,
  id,
  color,
  hoverColor,
  viewBox,
}) {
  const [mainColor, setMainColor] = useState(color);
  return (
    <svg
      id={id}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      viewBox={viewBox}
      onMouseEnter={() => setMainColor(hoverColor)}
      onMouseLeave={() => setMainColor(color)}
    >
      <g fill="none" fillRule="evenodd">
        <path
          stroke={mainColor}
          strokeDasharray="4 4"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.6"
          d="M18,35 C27.3888407,35 35,27.3888407 35,18 C35,8.61115925 27.3888407,1 18,1 C8.61115925,1 1,8.61115925 1,18 C1,27.3888407 8.61115925,35 18,35 Z"
        />
        <path
          fill={mainColor}
          fillRule="nonzero"
          d="M25,18 C25,18.525 24.65,18.875 24.125,18.875 L18.875,18.875 L18.875,24.125 C18.875,24.65 18.525,25 18,25 C17.475,25 17.125,24.65 17.125,24.125 L17.125,18.875 L11.875,18.875 C11.35,18.875 11,18.525 11,18 C11,17.475 11.35,17.125 11.875,17.125 L17.125,17.125 L17.125,11.875 C17.125,11.35 17.475,11 18,11 C18.525,11 18.875,11.35 18.875,11.875 L18.875,17.125 L24.125,17.125 C24.65,17.125 25,17.475 25,18 Z"
        />
      </g>
    </svg>
  );
}

IconAddOrg.defaultProps = {
  className: undefined,
  width: 36,
  height: 36,
  color: '#e0e0e0',
  hoverColor: '#e0e0e0',
  viewBox: '0,0,36,36',
};

IconAddOrg.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  id: PropTypes.string.isRequired,
  color: PropTypes.string,
  hoverColor: PropTypes.string,
  viewBox: PropTypes.string,
};

export default IconAddOrg;
